import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const formatEUR = (n) =>
  new Intl.NumberFormat("sl-SI", { style: "currency", currency: "EUR" }).format(n);

export const SHIPPING_COST = 14.9;
export const FREE_SHIPPING_LIMIT = 500;

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post("/admin/upload", fd, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("hc-admin-token")}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data.url;
}
